import React from 'react';
import ReactLoadable from 'react-loadable';

import { Loader } from '../loader/loader';

import styles from './loadable.scss';

class LoadingComponent extends React.Component<ReactLoadable.LoadingComponentProps> {
  public render() {
    return <Loader className={styles.loader} />;
  }
}

export function Loadable<P>(
  options: Pick<
    ReactLoadable.OptionsWithoutRender<P>,
    'delay' | 'loader' | 'timeout' | 'modules' | 'webpack'
  >,
) {
  return ReactLoadable({
    loading: LoadingComponent,
    ...options,
  });
}
